import AmioHttpService from './amio-http.service'

class IntentExamplesService extends AmioHttpService {

  create(intentId, example) {
    return this.requestPost(`/intents/${intentId}/examples`, {
      example
    })
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  update(exampleId, patch) {
    return this.requestPatch(`/intent-examples/${exampleId}`, patch)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  moveBulk(intentId, examples) {
    return this.requestPost(`/intents/${intentId}/move-examples-bulk`, { examples })
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  deleteBulk(intentId, exampleIds) {
    return this.requestPost(`/intents/${intentId}/delete-examples-bulk`, {
      example_ids: exampleIds
    })
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  list(intentId) {
    return this.requestGet(`/intents/${intentId}/examples`)
      .then(response => response.data)
      .then(intentExamples => intentExamples.map(adapt))
      .catch(err => {
        throw this.handleError(err)
      })
  }

}

function adapt(intentExample) {
  return {
    id: intentExample.id,
    intentId: intentExample.intent_id,
    example: intentExample.example,
    createdOn: intentExample.created_on
  }
}

export default new IntentExamplesService()
